import React, { useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import { Loading } from "../../../components/Loading/Loading";

import { DialogConfirm } from "../../../components/DialogService/DialogService";
import { useHistory } from "react-router-dom";
import { dataUserSession } from "../../../utilities/dataSession";
import { FooterButtonSigleCustom } from "../../../components/FooterButton/FooterButton";

//SERVICE
import { pContractorPlanDetailList, pContractorPlanDetailUpdate } from "../../../service/100/P110Service";

//PAGE
import P110List from "./P110List";
import ValidateService from "../../../components/ValidateService/ValidateService";

export default function P110() {
    const history = useHistory();
    const toast = useRef(null);

    const [loading, setLoading] = useState(false);
    const [errData, setErrData] = useState(null);

    const [requestSrh, setRequestSrh] = useState({ routeName: "", contractNo: "", routeNo: 0, userId: "" });

    //Data
    const [dataTable, setDataTable] = useState([]);
    const [count, setCount] = useState(0);
    const [dataForm, setDataForm] = useState({ contractorCode: "", contractorName: "", contractNo: "", routeNo: "" });

    // Dialog
    const [confirmDialog, setConfirmDialog] = useState(false);
    const [dialogOption, setdialogOption] = useState({
        header: "",
        content: "",
        onConfirm: () => {},
        onCancle: () => {},
        footerBtn: () => {},
    });

    useEffect(() => {
        if (dataUserSession()) {
            if (history.location.state) {
                setRequestSrh({
                    ...history.location.state.dataSrh,
                    userId: dataUserSession().userId,
                });
            } else {
                history.push("/109");
                // setRequestSrh({ contractNo: "ป.16-1/64", routeNo: 1, userId: dataUserSession().userId });
            }
        } else {
            history.push("/login");
        }
    }, []);
    useEffect(() => {
        onGetContractorPlanDetailList();
    }, [requestSrh]);

    const onGetContractorPlanDetailList = () => {
        setLoading(true);
        const req = {
            contractNo: requestSrh.contractNo,
            routeNo: requestSrh.routeNo,
            userId: requestSrh.userId,
        };

        pContractorPlanDetailList(req).then(
            (res) => {
                setLoading(false);
                if (res != undefined) {
                    let temp = [];
                    let index = 0;
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });
                        index++;
                    });
                    setDataTable(temp);
                    if (temp.length > 0) setDataForm({ ...dataForm, contractorCode: temp[0].contractorCode, contractorName: temp[0].contractorName });
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const showMessages = (severity = "error", summary = "", detail = "") => {
        toast.current.show({ severity: severity, summary: summary, detail: detail, life: 10000 });
    };

    const onInputTextChange = (e, key) => {
        const val = (e.target && e.target.value) || "";
        setDataForm({
            ...dataForm,
            [`${key}`]: val,
        });
    };

    const onSearch = (act, rowData) => {
        history.push({
            pathname: "/220",
            state: {},
        });
    };

    const handlerTableUpdateDataForm = (e, rowData, inputName) => {
        const objIndex = dataTable.findIndex((obj) => obj.index == rowData.index);
        dataTable[objIndex][inputName] = e;

        setCount(count + 1);
        setDataTable(dataTable);
    };

    const handlerSettingDialogConfirm = (header, content) => {
        setdialogOption({
            ...dialogOption,
            header: header,
            content: content,
            footerBtn: () => footerButtonSingle(),
            onCancle: () => setConfirmDialog(false),
        });
        setConfirmDialog({ open: true });
    };

    const footerButtonSingle = () => {
        const con = () => {
            // alert("/200");
            // history.push("/200");
            setConfirmDialog(false);
        };
        return <FooterButtonSigleCustom btnLabel="ตกลง" icon="pi pi-check" onClick={() => con()} />;
    };
    const submitForm = () => {
        setLoading(true);
        for (let index = 0; index < dataTable.length; index++) {
            const req = {
                contractNo: requestSrh.contractNo,
                planProgress: dataTable[index].planProgress === null ? 0 : dataTable[index].planProgress,
                planWithdraw: dataTable[index].planWithdraw === null ? 0 : dataTable[index].planWithdraw,
                routeNo: requestSrh.routeNo,
                userId: requestSrh.userId,
                weekNo: dataTable[index].weekNo,
            };

            pContractorPlanDetailUpdate(req).then(
                (res) => {
                    setLoading(false);
                    if (res.status === 200) {
                        if (index === dataTable.length - 1) {
                            handlerSettingDialogConfirm(res.data[0].statusCode === "C" ? "บันทึกสมบูรณ์" : "มีข้อผิดพลาด", res.data[0].statusText);
                            onGetContractorPlanDetailList();
                        }
                    } else {
                        showMessages("error", "เกิดข้อผิดพลาด", "บันทึกข้อมูลการรายงานผลผิดพลาด");
                    }
                },
                function (err) {
                    setLoading(false);
                    setErrData(err);
                }
            );
        }
    };

    return (
        <>
            <Loading loading={loading} />
            <ValidateService err={errData} setErr={setErrData} />
            <div className="p-grid crud-demo">
                <Toast ref={toast} position="top-right" />
                <div className="p-col-12">
                    <div className="card">
                        <div className="p-grid  p-fluid">
                            <div className="p-col-12 p-md-2"></div>
                            <div className="p-col-12 p-md-8">
                                <div className="p-grid p-fluid" style={{ marginBottom: "10px" }}>
                                    <div className="p-col-12 p-md-6">
                                        <label>รหัสบริษัท</label>
                                        <div className="p-inputgroup">
                                            <InputText id="contractorCode" value={dataForm.contractorCode} onChange={(e) => onInputTextChange(e, "contractorCode")} disabled={true} />
                                        </div>
                                    </div>
                                    <div className="p-col-12 p-md-6">
                                        <label>ชื่อบริษัท</label>
                                        <div className="p-inputgroup">
                                            <InputText id="contractorName" value={dataForm.contractorName} onChange={(e) => onInputTextChange(e, "contractorName")} disabled={true} />
                                        </div>
                                    </div>
                                </div>
                                <div className="p-grid p-fluid" style={{ marginBottom: "10px" }}>
                                    <div className="p-col-12 p-md-6">
                                        <label>เลขที่สัญญา</label>
                                        <div className="p-inputgroup">
                                            <InputText id="contractNo" value={requestSrh.contractNo} onChange={(e) => onInputTextChange(e, "contractNo")} disabled={true} />
                                        </div>
                                    </div>
                                    <div className="p-col-12 p-md-6">
                                        <label>เส้นทางที่</label>
                                        <div className="p-inputgroup">
                                            <InputText id="routeNo" value={requestSrh.routeName} onChange={(e) => onInputTextChange(e, "routeNo")} disabled={true} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="p-col-12 p-md-2"></div>
                        </div>
                        <P110List dataTable={dataTable} goPage={onSearch} setheadlerInpusText={handlerTableUpdateDataForm} dis={false} />
                        <div className="p-grid" style={{ textAlign: "center" }}>
                            <div className="p-col-12">
                                <Button className="p-button-success p-button p-mr-2 p-mb-2" icon="pi pi-save" label="บันทึก" style={{ width: 170 }} onClick={() => submitForm()} />
                                <Button className="p-button-secondary p-button p-mr-2 p-mb-2" icon="pi pi-arrow-left" label="กลับหน้าจอหลัก" style={{ width: 170, marginLeft: "5px" }} onClick={() => history.push("/109")} />
                            </div>
                        </div>
                    </div>
                </div>
                <DialogConfirm visible={confirmDialog.open} header={dialogOption.header} modal footer={dialogOption.footerBtn} onHide={() => setConfirmDialog(false)} textContent={dialogOption.content} />
            </div>
        </>
    );
}
